export enum ContractorCompanyFilterTypes {
  Company = 'company',
}
